import React from 'react';
import { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import ViewHistoricalResults from 'pages/HistoricalResults/components/ViewHistoricalResults/ViewHistoricalResults';
import ConfirmAccess from 'pages/ConfirmAccess/ConfirmAccess';
import AllClientDashboards from 'pages/Dashboard/components/AllClientDashboards/AllClientDashboards';
import ClientDashboard from 'pages/Dashboard/ClientDashboard';

import { AccessDataContext } from '../contextProviders/AccessDataContext';

import Dashboard from '../pages/Dashboard/Dashboard';
import Pricelists from '../pages/Pricelists/Pricelists';
import ClientPricelist from '../pages/Pricelists/components/ClientPricelist/ClientPricelist';
import HistoricalResults from '../pages/HistoricalResults/HistoricalResults';
import MasterPricelist from '../pages/Pricelists/components/MasterPricelist/MasterPricelist';
import AllClientPricelists from '../pages/Pricelists/components/AllClientPricelists/AllClientPricelists';
import StaffClocking from '../pages/Staff/components/StaffClocking/StaffClocking';
import Documents from '../pages/Documents/Documents';
import Profile from '../pages/Profile/Profile';
import { UserRoles } from '../enums/UserRoles';
import NavMenu from '../pages/NavMenu/NavMenu';
import './LoggedInRoutes.scss';
import envirolabLogo from '../resources/images/envirolab-intertek-oneline.png';
import 'devextreme/dist/css/dx.light.css';

function LoggedInRoutes() {
  const { securityRoles } = useContext(AccessDataContext);

  return (
    <Box id="siteContent">

        <Box id="sidebar">
          <Box className="logo">
            <img alt="Envirolab logo" src={envirolabLogo} />
          </Box>
          <NavMenu />
        </Box>

        <Box id="viewPane">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/pricelists" element={<Pricelists />} />
            <Route path="/pricelists/:client" element={<ClientPricelist />} />
            <Route path="/online-results" element={<HistoricalResults />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/online-results/:regtid/:branch" element={<ViewHistoricalResults />} />
            <Route path="/dashboard/:limsDatabase/:clientReference" element={<ClientDashboard />} />

            {securityRoles && securityRoles?.length > 0 && securityRoles?.filter((f) => f === UserRoles.Admin).length > 0 ? (
              <>
                <Route path="/master-pricelist" element={<MasterPricelist />} />
                <Route path="/client-pricelists/" element={<AllClientPricelists />} />
                <Route path="/client-dashboards/" element={<AllClientDashboards />} />
              </>
            ) : null}

            {securityRoles && securityRoles?.length > 0 && securityRoles?.filter((f) => f === UserRoles.Staff).length > 0 ? (
              <>
                <Route path="/staff-clocking" element={<StaffClocking />} />
              </>
            ) : null}

            <Route path="/profile" element={<Profile />} />
            <Route path="/confirm-access/:type/:id/:token/:accessType" element={<ConfirmAccess />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Box>
    </Box>
  );
}

export default LoggedInRoutes;
